import React from 'react';
import styled from 'styled-components';

import logo from '../../assets/logo.png';

const StyledHeader = styled.header`
  height: 70px;
  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Logo = styled.img`
  width: 110px;
  height: 65px;
`;

const CodeSymbol = styled.span`
  font-size: 40px;
  font-weight: bold;
  color: var(--color-primary);
`;

const BrandLogo = styled.div`
  width: auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Header: React.FC = () => (
  <StyledHeader>
    <BrandLogo>
      <CodeSymbol>{'<'}</CodeSymbol>
      <Logo src={logo} alt="Logo Dev Seridó" />
      <CodeSymbol>{'/>'}</CodeSymbol>
    </BrandLogo>
  </StyledHeader>
);

export default Header;
